module.exports = __webpack_public_path__ + "static/media/1001684DO.414d41c7.jpg";